module.exports = __webpack_public_path__ + "assets/img/language-zh.8c56d8eb.png";